import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component } from '@angular/core';
import { BaseCrudComponent } from '../../base';
import { GerenciamentoComissao } from '../../entity/gerenciamento-comissao.model';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { dataFimLimite } from 'app/util/custom.validators';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'gerenciamento-comissao-crud',
  templateUrl: './comissao-crud.component.html'
})
export class GerenciamentoComissaoCrudComponent extends BaseCrudComponent {
  controllerName = 'gerenciamento-comissao'
  gerenciamentoComissao: GerenciamentoComissao;
  controladorGerenciamento = false;
  cadastro = this.formBuilder.group({
    id_instituicao: [null, [Validators.required]],
    id_capacitadora: [null],
    radio_instituicao_capacitadora: [1],
    carga_horaria: [null, [Validators.required, Validators.min(1)]],
    id: [null],
    id_natureza: [null, [Validators.required]],
    observacao: [null, [Validators.maxLength(4000)]],
    titulo: [null, [Validators.required, Validators.maxLength(100)]],
    cpf: [null],
    data_fim: [null, [Validators.required]],
    codigo: [null],
    id_situacao: [null],
    anexo_gerenciar_atividade: this.formBuilder.group({
      id: [null]
    }),
  });

  recursoFiltro: RecursoFiltro = new RecursoFiltro();

  listaCapacitadora: any[] = [];
  listaAnexos: any[] = [];
  listaDadosInstituicao: SelectItem[] = [];
  listaTipoAtividade: SelectItem[] = [];
  listaPntCFC: any[];
  listaPntCRC: any[];
  listaResumo: any[];
  listaRelatores: SelectItem[] = [];
  stepObject: any;
  mostrarCodigo: boolean = false;

  validateForm= false;

  setStepObject(obj: any) {
    this.stepObject = obj;
  }
  init() {
    this.service.ListarTodos('instituicao').subscribe(data => {
      this.listaDadosInstituicao = data;
    });
    this.service.ListarTodosCapacitadoraCombo().subscribe(data => {
      this.listaCapacitadora = data;
    });
    this.cadastro.get('id_natureza').disable();
    if (this.acao == 'editar') {
      this.cadastro.get('data_fim').disable();
    }
  }

  afterInit() {
    this.cadastro.get('data_fim').valueChanges.subscribe(x => {

      this.verificarPrestacaoForaDoPrazo(x, this.cadastro);
      
      this.observableUtilPanelDoc.setBlockedPanel(true);
      this.service.ListarTodos('natureza', { query: 'Comissão', data: this.cadastro.get('data_fim').value }).subscribe(data => {
        this.listaTipoAtividade = data;
        this.cadastro.get('id_natureza').enable();
        this.observableUtilPanelDoc.setBlockedPanel(false);
      });
    });
    this.cadastro.get('radio_instituicao_capacitadora').valueChanges.subscribe(valor => {
      if (valor == 1) {
        this.cadastro.get('id_instituicao').setValidators([Validators.required]);
        this.cadastro.get('id_instituicao').updateValueAndValidity();
        this.cadastro.get('id_capacitadora').clearValidators();
        this.cadastro.get('id_capacitadora').setValue(null);
        this.cadastro.get('id_capacitadora').updateValueAndValidity();
      } else {
        this.cadastro.get('id_capacitadora').setValidators([Validators.required]);
        this.cadastro.get('id_capacitadora').updateValueAndValidity();
        this.cadastro.get('id_instituicao').clearValidators();
        this.cadastro.get('id_instituicao').setValue(null)
        this.cadastro.get('id_instituicao').updateValueAndValidity();
      }
    })
  }

  afterLoad() {
    this.mostrarCodigo = true;
    this.gerenciamentoComissao = this.obj;
    if (this.gerenciamentoComissao.id_instituicao != null) {
      this.cadastro.get('radio_instituicao_capacitadora').setValue(1);
    } else {
      this.cadastro.get('radio_instituicao_capacitadora').setValue(2);
    }
    if (this.obj.anexo_gerenciar_atividade != null) {
      this.obj.anexo_gerenciar_atividade.forEach(x => {
        x.show = true;
        this.listaAnexos.push(x);
      });
    }
    this.obj.homologacao_comissao.map(item => {
      this.service.ListarRelatores('listaRelatoresHomologacao', { query: item.id }).subscribe(
        relatores => {
          this.listaRelatores = relatores;
        }
      );
      this.service.ListarTodos('resumoHomologacao', { query: item.id }).subscribe(
        data => {
          this.listaResumo = data;
        }
      );
      this.service.ListarPontuacaoHomologacao('homologacao-comissao', item.id, 'Comissão CFC').subscribe(retorno => {
        this.listaPntCFC = retorno;
      });
      this.service.ListarPontuacaoHomologacao('homologacao-comissao', item.id, 'Comissão CRC').subscribe(retorno => {
        this.listaPntCRC = retorno;
      });
    });
  }
  carregarObj(event: any) {
    this.gerenciamentoComissao = new GerenciamentoComissao(this.cadastro.value, this.listaAnexos);
  }
  finalizar(event: any) {
    this.gerenciamentoComissao.id_lotacao = parseInt(localStorage.getItem('lotacao'));
    if (this.obj != null) {
      this.gerenciamentoComissao.data_cadastro = this.obj.data_cadastro;
    }
    this.doFinalAction(this.gerenciamentoComissao);
  }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-comissao/crud/comissao-crud.component.ts